import React from "react";
import {LicenseButtonsComponent} from "../DynamicFormTypes.ts";

const openAppraiserProfile = () => {
    window.open(`/appraiser/profile/me`, '_blank');
};

const refreshPage = () => {
    location.reload();
};

interface LicenseButtonsProps {
    component: LicenseButtonsComponent;
}

export const LicenseButtons: React.FC<LicenseButtonsProps> = ({component: _component}) => {
    return (
        <div className="mt-6 flex gap-3">
            <button
                onClick={openAppraiserProfile}
                // Temporarily disabled until functionality is ironed out
                disabled={true}
                className="disabled:bg-blue-50 disabled:text-blue-300 disabled:border-blue-300 px-4 py-2 border rounded border-blue-600 text-blue-600 hover:bg-blue-200 bg-blue-100"
            >
                Edit License/Documents
            </button>
            <button
                onClick={refreshPage}
                // Temporarily disabled until functionality is ironed out
                disabled={true}
                className="disabled:bg-blue-50 disabled:text-blue-300 disabled:border-blue-300 px-4 py-2 border rounded border-blue-600 text-blue-600 hover:bg-blue-200 bg-blue-100"
            >
                Refresh License Info
            </button>
        </div>
    );
}